import { ErrorMessage } from "formik";
import { FormInput } from "../../../../components/form/FormInput";
import { Label } from "../../../../components/form/Label";

export const YourInformationSection = () => (
  <div className="seal-form-section">
    <h2 className="sub-headline">Your information</h2>

    <Label label="Full name *" field="fullName" className="field-spacing" />
    <FormInput name="fullName" type="text" autoComplete="name" className="input-text" />
    <ErrorMessage name="fullName" className="input-error" component="span" />

    <Label label="Job title or role *" field="jobTitle" className="field-spacing" />
    <FormInput name="jobTitle" type="text" autoComplete="organization-title" className="input-text" />
    <ErrorMessage name="jobTitle" className="input-error" component="span" />

    <Label label="Business email *" field="email" className="field-spacing" />
    <FormInput name="email" type="email" autoComplete="email" className="input-text" />
    <ErrorMessage name="email" className="input-error" component="span" />
    <span className="form-fields-sub-text">
      Registration updates, review questions, compliance notices, and seal-program materials will be sent to this address.
    </span>
    
    <Label label="Confirm business email *" field="confirmEmail" className="field-spacing" />
    <FormInput name="confirmEmail" type="email" autoComplete="off" className="input-text" />
    <ErrorMessage name="confirmEmail" className="input-error" component="span" />
  </div>
);
